"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Sign = function Sign(props) {
  return _react2["default"].createElement("svg", (0, _extends3["default"])({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _react2["default"].createElement("path", {
    className: "fill",
    d: "M15.835 3.127a.61.61 0 0 1 0 .836L14.63 5.225l-3.623-3.798-3.226 3.38-.797-.835L10.608.173A.553.553 0 0 1 11.007 0c.15 0 .293.063.398.173l.81.849.406-.426a.545.545 0 0 1 .797 0l2.417 2.531zm-6.85 8.016L5.77 7.775l4.85-5.082 3.213 3.368-4.85 5.082zm-.95.676l-3.293 1.15a.545.545 0 0 1-.577-.142.608.608 0 0 1-.136-.604l1.098-3.452 2.909 3.048zM0 16v-2h16v2H0z"
  }));
};

exports["default"] = Sign;